import type { DeviceCoords } from '@/services/device-service/devices'

export interface MapCoords {
  lat: number
  lng: number
}

export interface MapLocation {
  center: MapCoords
  zoom: number
  lastZoom: number
}

export interface MapSettings {
  pinMeasurementType: number
  pinAqiType: number
  deviceModels: string[] | null
  showMine: boolean
  showPublic: boolean
  showShared: boolean
  showIndoor: boolean
  showOutdoor: boolean
}

export interface DeviceToMove {
  deviceId: string
  coords: DeviceCoords
}

export interface DeviceToView {
  deviceId: string
  deviceType: number
  coords: DeviceCoords
}

export interface MapState {
  movingMode: boolean
  deviceToMove: DeviceToMove | null
  deviceViewMode: boolean
  deviceToView: DeviceToView | null
  location: MapLocation
  shownSettings: MapSettings
}

export enum MAP_MUTATIONS {
  SET_MOVING_PIN = 'setMovingPin',
  SET_LAST_ZOOM = 'setLastZoom',
  SET_ZOOM = 'setZoom',
  SET_CENTER = 'setCenter',
  SET_MOVING_MODE = 'setMovingMode',
  SET_DEVICE_VIEW_MODE = 'setDeviceViewMode',
  SET_DEVICE_TO_VIEW = 'setDeviceToView',
  UPDATE_SETTINGS = 'updateSettings',
  UPDATE_LOCATION = 'updateLocation'
}

export enum MAP_ACTIONS {
  START_MOVING = 'startMoving',
  STOP_MOVING = 'stopMoving',
  CANCEL_MOVE = 'cancelMove',
  SET_ZOOM = 'setZoom',
  SET_CENTER = 'setCenter',
  UPDATE_SETTINGS = 'updateSettings',
  START_DEVICE_VIEW_MODE = 'startDeviceViewMode',
  STOP_DEVICE_VIEW_MODE = 'stopDeviceViewMode'
}

export enum MAP_GETTERS {
  GET_MEASUREMENT_TYPE = 'getMeasurementType',
  GET_AQI_TYPE = 'getAqiType',
  GET_DEVICE_MODELS = 'getDeviceModels',
  GET_SHOW_MINE = 'getShowMine',
  GET_SHOW_PUBLIC = 'getShowPublic',
  GET_SHOW_SHARED = 'getShowShared',
  GET_SHOW_INDOOR = 'getShowIndoor',
  GET_SHOW_OUTDOOR = 'getShowOutdoor'
}

export type UpdateSettingsPayload = Partial<MapSettings>
